<template>
  <div class="n_select">
    <v-head></v-head>
    <div id="rg-gallery" class="rg-gallery">
      <div class="rg-view">
        <a  class="rg-view-full"></a>
        <a  class="rg-view-thumbs rg-view-selected"></a>
      </div>

      <div class="rg-thumbs">
        <!-- Elastislide Carousel Thumbnail Viewer -->
        <div class="es-carousel-wrapper">
          <div class="es-nav">
            <span class="es-nav-prev">Previous</span>
            <span class="es-nav-next">Next</span>
          </div>
          <div class="es-carousel bbb">
            <ul>
              <li v-for="b in n_src">
                <a>
                  <img :src="b.src_thumb"
                       data-large={{b.src}}
                       alt="image01" data-description="NAERSI SELECTED">
                </a>
              </li>
            </ul>
          </div>
          <div class="es-nav">
            <span class="es-nav-prev">Previous</span>
            <span class="es-nav-next">Next</span>
          </div>
        </div>
        <!-- End Elastislide Carousel Thumbnail Viewer -->
      </div><!-- rg-thumbs -->
      <div class="bigImg">
          <img src="" id="bigImgUrl">
      </div>

      <div class="rg-image-wrapper aaa">
        <div class="rg-image-nav">
          <a  class="rg-image-nav-prev">Previous Image</a>
          <a  class="rg-image-nav-next">Next Image</a>
        </div>
        <!--<div class="rg-image"><img src="./index_files/20160721050627376.jpg"></div>-->
        <div class="rg-loading"></div>
        <div class="rg-caption-wrapper">
          <div class="rg-caption">
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>

  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
          n_src:[],
          urls:"http://112.74.184.45:882/"
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    methods :{

    },
    ready () {
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getImageByTypeId/" + this.$route.params.name,
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(695159,data);
            _this.n_src = data.data;
            console.log(369852,_this.n_src)
          setTimeout(function () {
            //点击小图切换js
            $('.es-carousel ul li a img').click(function () {
              var urladdress = $(this).attr('data-large');
              $('#bigImgUrl').attr('src',urladdress);
            });
            $('.es-carousel ul li a img').eq(0).click();
            //小图滚动
            var ulWidth = $('.es-carousel ul li').width() * $('.es-carousel ul li').length
            $('.es-carousel ul').width(ulWidth);

            //点击左右按钮滚动列表
            $('.es-nav-next').click(function(){
              var liWidth = $('.es-carousel ul li').width();
              var cssLeft = parseFloat($('.es-carousel ul').css('left'));
              var stop = $('.es-carousel ul li').length - 12;
              var stoplength = $('.es-carousel ul li').width() * stop;

              //假设列表有13个
              //页面最多宽度展示10个
              //13-10 = 3
              //3个乘以每个的宽度
              //如果3个的宽度等于cssleft的值，就不让滚动
              $('.es-carousel ul').css('left',cssLeft - liWidth);
              if(Math.abs(cssLeft) === stoplength){
                $('.es-nav-next').click(function(){
                  $('.es-carousel ul').css('left',cssLeft - liWidth);
                })
              }
              if($('.es-carousel ul li').length<12){
                $('.es-nav-next').click(function(){
                  $('.es-carousel ul').css('left',cssLeft - liWidth);
                })
              }
            });
            $('.es-nav-prev').click(function(){
              var liWidth = $('.es-carousel ul li').width();
              var cssLeft = parseInt($('.es-carousel ul').css('left'));
              var stopright = $('.es-carousel ul li').length - 12;
              var stoprightlength = $('.es-carousel ul li').width() * stopright;
              //假设列表有13个
              //页面最多宽度展示10个
              //13-10 = 3
              //3个乘以每个的宽度
              //如果3个的宽度等于cssleft的值，就不让滚动
              console.log(1111,stopright);
              console.log(444,liWidth);
              console.log(222,stoprightlength)
              console.log(333,cssLeft)
              console.log(5555,Math.abs(cssLeft))

              $('.es-carousel ul').css('left',cssLeft + liWidth);

              if(Math.abs(cssLeft) === stoprightlength){
                $('.es-nav-prev').click(function(){
                  $('.es-carousel ul').css('left',cssLeft + liWidth);
                })
              }
            });
          },100)
          }
        },
      });
    }
  }
</script>

<style>
  .n_select{width: 9rem;margin: 0 auto;}
  .es-carousel ul{display: block; margin-left: 0px; transition: all 1s; position: relative;left: 0}
  .es-carousel ul li{  width: 0.7rem; text-align: center}
  .es-carousel ul li a{border-width: 0.02rem;}
  .rg-loading{display: none}
  .rg-caption p{font-size: 0.18rem}
  .aaa{width: 8.3rem;position: absolute;top:2.1rem;display: none}
  .rg-gallery{margin-top: 0.5rem}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .n_select{width: 100%;margin: 0 auto;}
    .es-carousel{overflow: hidden}
    .es-carousel ul{display: block; margin-left: 0px; transition: all 2s; position: relative;left: 0 }
    .es-carousel ul li{ width: 0.7rem;}
    .es-carousel ul li a{border-width: 0.02rem;}
    .es-nav span{margin-top: -3px;}
    .rg-loading{display: none}
    .rg-caption p{font-size: 0.18rem}
    .aaa{width: 83%;position: absolute;top:2.1rem;display: none}
    .bbb{width: 100%}
    .rg-gallery{margin-top: 0.5rem}
  }
  .bigImg{ width: 100%}
  .bigImg img{ width: 100%}
</style>




// WEBPACK FOOTER //
// n_select.vue?79c8a2a7